import React, { useState, useContext, useEffect, Suspense, lazy } from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './_Layouts/header/Header';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Footer from './_Layouts/footer/Footer';
import { HelmetProvider } from 'react-helmet-async';
import { NotFoundContext } from './contexts/NotFoundContext';
import { SiteProvider, useSiteContext } from './contexts/SiteContext';
import SiteDataExample from './components/SiteDataExample';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';

// Lazy loaded pages
const Homepage = lazy(() => import('./pages/homepage/Homepage'));
const History = lazy(() => import('./pages/history/History'));
const PolicyPage = lazy(() => import('./pages/policy/Policy'));
const MissionPage = lazy(() => import('./pages/mission/Mission'));
const ScheduledCargo = lazy(() => import('./pages/services/scheduled-cargo/Scheduled-Cargo'));
const CharterCargo = lazy(() => import('./pages/services/charter-cargo/Charter-Cargo'));
const RampHandling = lazy(() => import('./pages/services/ramphandling/RampHandling'));
const HumanResources = lazy(() => import('./pages/humanresources/HumanResources'));
const Warehouse = lazy(() => import('./pages/services/warehouse/WareHouse'));
const TechnicalPage = lazy(() => import('./pages/services/technical/Technical'));
const LiveAnimals = lazy(() => import('./pages/services/Special-Cargo/live-animals/Live-Animals'));
const DangerousGoodsPage = lazy(() => import('./pages/services/Special-Cargo/dangerous-goods/Dangerous'));
const TruckService = lazy(() => import('./pages/services/truck-service/Truck'));
const NewsDetail = lazy(() => import('./pages/news/detail/NewsDetail'));
const News = lazy(() => import('./pages/news/News'));
const ContactPage = lazy(() => import('./pages/contact/Contact'));
const Sustainability = lazy(() => import('./pages/sustainability/Sustainability'));
const NetworkPage = lazy(() => import('./pages/network/Network'));
const BookNowPage = lazy(() => import('./pages/book/Book'));
const PerishableCargoPage = lazy(() => import('./pages/services/perishable-cargo/PerishableCargo'));
const PharmaShipmentPage = lazy(() => import('./pages/services/pharma-shipment/PharmaShipment'));
const EthicPage = lazy(() => import('./pages/ethic/Ethic'));
const QualityPage = lazy(() => import('./pages/quality/quality'));
const NotFound = lazy(() => import('./pages/NotFound'));
const CarreerTest = lazy(() => import('./pages/carreer-test/CarreerTest'));
const SustainabilityTest = lazy(() => import('./pages/sustainabilitytest/Sustainability-test'));


// Warehouse Test
const WarehouseTest = lazy(() => import('./pages/services/warehouse-test/WarehouseTest'));

// Belirli bir URL'e girildiğinde dili zorla değiştiren yardımcı bileşen
function ForceLanguage({ children, lang }) {
  const { changeLanguage, currentLanguageCode } = useSiteContext();

  useEffect(() => {
    // Sadece componenti render ettiğimiz URL'in diline uyum sağlaması için
    if (currentLanguageCode !== lang) {
      const langName = lang === 'tr' ? 'Türkçe' : 'English';
      changeLanguage(lang, langName, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]); // Sadece rotaya ilk girildiğinde veya lang değiştiğinde tetiklensin

  return children;
}

function AppContent() {
  const { isNotFound } = useContext(NotFoundContext);
  const { loading } = useSiteContext();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
      {!isNotFound && <Header />}
      <main style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <Suspense fallback={<LoadingScreen />}>
        <Routes>


          {/* Warehouse Test */}
          {/* <Route path="/antrepo-test" element={<ForceLanguage lang="tr"><WarehouseTest /></ForceLanguage>} />
          <Route path="/warehouse-test" element={<ForceLanguage lang="en"><WarehouseTest /></ForceLanguage>} /> */}


          {/* Carreer Test
          <Route path="/kariyer-test" element={<ForceLanguage lang="tr"><CarreerTest /></ForceLanguage>} />
          <Route path="/career-test" element={<ForceLanguage lang="en"><CarreerTest /></ForceLanguage>} /> */}

          {/* Sustainability Test */}
          <Route path="/surdurulebilirlik-test" element={<ForceLanguage lang="tr"><SustainabilityTest /></ForceLanguage>} />
          <Route path="/sustainability-test" element={<ForceLanguage lang="en"><SustainabilityTest /></ForceLanguage>} />

          {/* HOMEPAGE */}
          <Route path="/" element={<Homepage />} />

          {/* HISTORY */}
          <Route path="/tarihce" element={<ForceLanguage lang="tr"><History /></ForceLanguage>} />
          <Route path="/history" element={<ForceLanguage lang="en"><History /></ForceLanguage>} />

          {/* POLICIES */}
          <Route path="/politikalar" element={<ForceLanguage lang="tr"><PolicyPage /></ForceLanguage>} />
          <Route path="/policies" element={<ForceLanguage lang="en"><PolicyPage /></ForceLanguage>} />

          {/* MISSION */}
          <Route path="/misyon-vizyon-degerler" element={<ForceLanguage lang="tr"><MissionPage /></ForceLanguage>} />
          <Route path="/mission-vision-values" element={<ForceLanguage lang="en"><MissionPage /></ForceLanguage>} />

          {/* SCHEDULED */}
          <Route path="/tarifeli-ucus" element={<ForceLanguage lang="tr"><ScheduledCargo /></ForceLanguage>} />
          <Route path="/scheduled-flights" element={<ForceLanguage lang="en"><ScheduledCargo /></ForceLanguage>} />

          {/* CHARTER */}
          <Route path="/charter-ucus" element={<ForceLanguage lang="tr"><CharterCargo /></ForceLanguage>} />
          <Route path="/charter-flights" element={<ForceLanguage lang="en"><CharterCargo /></ForceLanguage>} />

          {/* GROUND HANDLING */}
          <Route path="/yer-hizmetleri" element={<ForceLanguage lang="tr"><RampHandling /></ForceLanguage>} />
          <Route path="/ground-handling" element={<ForceLanguage lang="en"><RampHandling /></ForceLanguage>} />

          {/* CAREERS */}
          <Route path="/kariyer" element={<ForceLanguage lang="tr"><HumanResources /></ForceLanguage>} />
          <Route path="/careers" element={<ForceLanguage lang="en"><HumanResources /></ForceLanguage>} />

          {/* WAREHOUSE */}
          <Route path="/antrepo" element={<ForceLanguage lang="tr"><Warehouse /></ForceLanguage>} />
          <Route path="/warehouse" element={<ForceLanguage lang="en"><Warehouse /></ForceLanguage>} />

          {/* TECHNICAL */}
          <Route path="/teknik-hizmetler" element={<ForceLanguage lang="tr"><TechnicalPage /></ForceLanguage>} />
          <Route path="/technical-services" element={<ForceLanguage lang="en"><TechnicalPage /></ForceLanguage>} />

          {/* LIVE ANIMALS */}
          <Route path="/canli-hayvan-tasimaciligi" element={<ForceLanguage lang="tr"><LiveAnimals /></ForceLanguage>} />
          <Route path="/live-animals" element={<ForceLanguage lang="en"><LiveAnimals /></ForceLanguage>} />

          {/* DANGEROUS GOODS */}
          <Route path="/tehlikeli-maddeler" element={<ForceLanguage lang="tr"><DangerousGoodsPage /></ForceLanguage>} />
          <Route path="/dangerous-goods" element={<ForceLanguage lang="en"><DangerousGoodsPage /></ForceLanguage>} />

          {/* NEWS */}
          <Route path="/haberler" element={<News />} />
          <Route path="/news" element={<News />} />
          <Route path="/haberler/:slug" element={<NewsDetail />} />
          <Route path="/news/:slug" element={<NewsDetail />} />

          {/* TRUCK */}
          <Route path="/karayolu-tasimaciligi" element={<ForceLanguage lang="tr"><TruckService /></ForceLanguage>} />
          <Route path="/truck-services" element={<ForceLanguage lang="en"><TruckService /></ForceLanguage>} />

          {/* CONTACT */}
          <Route path="/iletisim" element={<ForceLanguage lang="tr"><ContactPage /></ForceLanguage>} />
          <Route path="/contact" element={<ForceLanguage lang="en"><ContactPage /></ForceLanguage>} />

          {/* SUSTAINABILITY */}
          <Route path="/surdurulebilirlik" element={<ForceLanguage lang="tr"><Sustainability /></ForceLanguage>} />
          <Route path="/sustainability" element={<ForceLanguage lang="en"><Sustainability /></ForceLanguage>} />

          {/* NETWORK */}
          <Route path="/ag-ve-filo" element={<ForceLanguage lang="tr"><NetworkPage /></ForceLanguage>} />
          <Route path="/network-and-fleet" element={<ForceLanguage lang="en"><NetworkPage /></ForceLanguage>} />

          {/* BOOK NOW */}
          <Route path="/rezervasyon" element={<ForceLanguage lang="tr"><BookNowPage /></ForceLanguage>} />
          <Route path="/book-now" element={<ForceLanguage lang="en"><BookNowPage /></ForceLanguage>} />

          {/* PHARMA */}
          <Route path="/bozulabilir-ve-ilac-kargosu" element={<ForceLanguage lang="tr"><PerishableCargoPage /></ForceLanguage>} />
          <Route path="/perishable-and-pharma-cargo" element={<ForceLanguage lang="en"><PerishableCargoPage /></ForceLanguage>} />
          <Route path="/ilac-tasimaciligi" element={<ForceLanguage lang="tr"><PharmaShipmentPage /></ForceLanguage>} />
          <Route path="/pharma-shipment" element={<ForceLanguage lang="en"><PharmaShipmentPage /></ForceLanguage>} />

          {/* ETHIC & QUALITY */}
          <Route path="/etik-hatti" element={<ForceLanguage lang="tr"><EthicPage /></ForceLanguage>} />
          <Route path="/ethic-hotline" element={<ForceLanguage lang="en"><EthicPage /></ForceLanguage>} />
          <Route path="/kalite-standartlari" element={<ForceLanguage lang="tr"><QualityPage /></ForceLanguage>} />
          <Route path="/quality-standards" element={<ForceLanguage lang="en"><QualityPage /></ForceLanguage>} />

          <Route path="/test-site-data" element={<SiteDataExample />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      </main>
      {!isNotFound && <Footer />}
    </>
  );
}

function App() {
  const [isNotFound, setIsNotFound] = useState(false);

  return (
    <HelmetProvider>
      <NotFoundContext.Provider value={{ isNotFound, setIsNotFound }}>
        <BrowserRouter>
          <SiteProvider>
            <AppContent />
          </SiteProvider>

        </BrowserRouter>
      </NotFoundContext.Provider>
    </HelmetProvider>
  );
}

export default App;
